import { render, staticRenderFns } from "./EmbeddedHeader.vue?vue&type=template&id=6d9c4e5a&scoped=true"
import script from "./EmbeddedHeader.vue?vue&type=script&lang=js"
export * from "./EmbeddedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c4e5a",
  null
  
)

export default component.exports